@if (isOpen()) {
<div class="flex flex-col w-[32rem] max-sm:w-full h-full bg-white rounded-lg shadow-xl flex-shrink-0 overflow-hidden
                animate-[slideInRight_0.2s_ease-out]">
    <div class="flex items-center justify-between border-b p-2 flex-shrink-0">
        <div class="flex items-center gap-2">
            <img [src]="'images/bob_agent/bob.svg' | assetUrl" alt="Ask Bob" class="w-6 h-6" />
            <h2 class="text-base font-semibold text-gray-800">Ask Bob</h2>
        </div>
        <app-button icon="pi pi-times" variant="ghost" severity="contrast" (clicked)="chatSidebarService.close()" />
    </div>
    <div class="flex-1 min-h-0 overflow-hidden">
        @switch (chatType()) {
        @case ('document') {
        @if (chatConfig().contractId) {
        <app-document-chat-tab [contractId]="chatConfig().contractId"
            [documentTypeId]="chatConfig().documentTypeId ?? ''" [projectId]="chatConfig().projectId ?? ''"
            [formQuestions]="chatConfig().formQuestions ?? []"
            [selectedFormQuestionId]="chatConfig().selectedFormQuestionId ?? null"
            [embeddingsStatus]="resolvedEmbeddingsStatus" />
        }
        }
        @case ('qna') {
        @if (chatConfig().contractId) {
        <app-qna-chat-tab [contractId]="chatConfig().contractId" [documentTypeId]="chatConfig().documentTypeId ?? ''"
            [projectId]="chatConfig().projectId ?? ''" [formQuestions]="chatConfig().formQuestions ?? []"
            [selectedFormQuestionId]="chatConfig().selectedFormQuestionId ?? null" />
        }
        }
        @case ('compare') {
        @if (chatConfig().contractId && chatConfig().comparisonId) {
        <app-compare-chat-tab [contractId]="chatConfig().contractId" [comparisonId]="chatConfig().comparisonId!"
            [compareDocuments]="chatConfig().compareDocuments ?? []" [kpiDocuments]="chatConfig().kpiDocuments ?? []"
            [documentTypeId]="chatConfig().documentTypeId ?? ''" [projectId]="chatConfig().projectId ?? ''"
            [embeddingsStatus]="resolvedEmbeddingsStatus" />
        }
        }
        @case ('geotechnical') {
        @if (chatConfig().contractId) {
        <!-- Geotechnical analysis chat tab – passes the analysis report ID as contractId -->
        <app-geotechnical-chat-tab [contractId]="chatConfig().contractId" />
        }
        }
        }
    </div>
</div>
}
